import { __rest } from 'tslib';
import React, { useState, useMemo } from 'react';
import { Select } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ChevronUp, ChevronDown } from '@piiqtechnologies/svg-icons';
import { PeekIconButton } from './PeekIconButton.js';
import { PeekMenuItem } from './PeekMenuItem.js';

// forwardRef: Select's menu attaches refs to its options for keyboard focus
// management; a plain wrapper drops them.
const PeekSelectOption = React.forwardRef((props, ref) => {
    return React.createElement(PeekMenuItem, Object.assign({ ref: ref }, props));
});
const PeekSelect = styled(React.forwardRef((_a, ref) => {
    var { centerText, showBorder, MenuProps, inputProps } = _a, props = __rest(_a, ["centerText", "showBorder", "MenuProps", "inputProps"]);
    const [expanded, setExpanded] = useState(false);
    const toggleExpanded = () => {
        setExpanded(!expanded);
    };
    const isDisabled = useMemo(() => {
        return props.disabled || (inputProps === null || inputProps === void 0 ? void 0 : inputProps.disabled) ? props.disabled || (inputProps === null || inputProps === void 0 ? void 0 : inputProps.disabled) : expanded;
    }, []);
    return (React.createElement(Select, Object.assign({ ref: ref, onOpen: toggleExpanded, onClose: toggleExpanded, open: isDisabled ? false : expanded, MenuProps: Object.assign({ PaperProps: {
                sx: {
                    mt: 1.2,
                    borderRadius: 0.8,
                },
            }, MenuListProps: {
                sx: {
                    pt: 0,
                    pb: 0,
                },
            } }, MenuProps), IconComponent: () => (React.createElement(PeekIconButton, { color: "primary", bordered: false, onClick: toggleExpanded, sx: {
                px: 0,
                mr: 1.5,
                opacity: 0.5,
                ":hover": { bgcolor: "transparent" },
            } }, (expanded && !isDisabled && React.createElement(ChevronUp, { height: 18, width: 18 })) || React.createElement(ChevronDown, { height: 18, width: 18 }))), inputProps: inputProps }, props)));
}))(({ centerText, showBorder, theme }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, theme.typography.h5), { borderRadius: theme.spacing(0.8), backgroundColor: theme.palette.primary.contrastText, border: `${theme.spacing(0.05)} solid ${theme.palette.grey[100]}` }), (centerText && { textAlign: "center" })), (showBorder && {
    border: `${theme.spacing(0.05)} solid ${theme.palette.grey[100]}`,
    boxShadow: "none",
})), { "& .MuiSelect-select": Object.assign(Object.assign({}, theme.typography.h5), { padding: `${theme.spacing(0.6)} ${theme.spacing(1.5)} !important`, border: "none", minHeight: "unset !important", "&.Mui-disabled": {
            backgroundColor: theme.palette.grey[50],
        } }), "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
        borderStyle: "unset !important",
    } })));

export { PeekSelect, PeekSelectOption, PeekSelect as default };
